import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/(sources)/exchanges/')({
  beforeLoad: () => {
    throw redirect({ to: '/sources' });
  },
});
